import React, { useState, useEffect } from "react";
import classes from "./styles/style.module.css";
import { motion } from "framer-motion";
import appApi from "../../../assets/utils/AppApi";
import errorHandler from "../../../assets/utils/ErrorHandler";

const itemContainer = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  },
};

const PreMatchMenuElement = ({ id, type, typeText, bgColor, src, score }) => {
  const [totalQuestons, setTotalQuestions] = useState(0);

  useEffect(() => {
    if (type) {
      getQuestionsCount();
    } else {
      getExposedQuestionsCount();
    }
    return () => {
      setTotalQuestions(0);
    };
  }, []);

  async function getQuestionsCount() {
    try {
      await appApi
        .post(`/quizQuestion/getNumberOfAllQuestionType`, {
          type: type,
          quizId: id,
        })
        .then(({ data }) => {
          setTotalQuestions(data.numberOfQuestionType);
        });
    } catch (error) {
      errorHandler(error);
    }
  }

  async function getExposedQuestionsCount() {
    try {
      await appApi
        .post(`/quizQuestion/getNumberOfAllQuestionType`, {
          exposed: true,
          quizId: id,
        })
        .then(({ data }) => {
          setTotalQuestions(data.numberOfQuestionType);
        });
    } catch (error) {
      errorHandler(error);
    }
  }

  let colorClass = classes.blueBg;
  if (bgColor === "blue") {
    colorClass = classes.blueBg;
  } else if (bgColor === "pink") {
    colorClass = classes.pinkBg;
  } else if (bgColor === "lightBlue") {
    colorClass = classes.lightBlue;
  } else {
    colorClass = classes.purpleBg;
  }
  const menuElementClasses = [classes.quesitonMenuElement, colorClass];
  if (totalQuestons === 0) {
    menuElementClasses.push(classes.disabled);
  }
  return (
    <motion.div
      variants={itemContainer}
      className={menuElementClasses.join(" ")}
    >
      <img src={src} alt={typeText} />
      <div className={classes.typeTextContainer}>
        <p>{`${typeText} (${totalQuestons})`}</p>
        <p>{`${score} امتیازی`}</p>
      </div>
    </motion.div>
  );
};

export default PreMatchMenuElement;
